module.exports = __webpack_public_path__ + "img/electricCar-dark-grey.a4b41c6b.svg";